import { useMemo } from "react";

import { useKeywordsCampaignsContext } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContext";
import { getMaxAmountOfRemainingKeywordsForRankTracker } from "app/pages/digital-marketing/keywords-campaigns/wizard/utils";

export const useIsKeywordsLimitExceeded = (addedTrackedSearches: number): boolean => {
    const { campaignsConsumptionMetrics, myUserConsumptionMetrics } = useKeywordsCampaignsContext();

    const remainingKeywords = useMemo(() => {
        if (!campaignsConsumptionMetrics || !myUserConsumptionMetrics) {
            // Metrics not yet loaded — treat remaining quota as unlimited to avoid blocking the button prematurely
            return Infinity;
        }
        return getMaxAmountOfRemainingKeywordsForRankTracker(campaignsConsumptionMetrics, myUserConsumptionMetrics);
    }, [campaignsConsumptionMetrics, myUserConsumptionMetrics]);

    return addedTrackedSearches > remainingKeywords;
};
